import {postWithAuth} from '@/api'
import {ProcessNewPaymentRequest, ProcessNewPaymentResponse} from '@/stores/transactions/ProcessNewPaymentStore'

export const fetchProcessNewPayment = (request: ProcessNewPaymentRequest) =>
    postWithAuth<ProcessNewPaymentResponse>('/oppapi/transaction/operation/recurring', request)
